import { type MediumIcon, stenaAnimals, stenaHazardous } from '@stenajs-webui/elements';
import { Information } from '../../../../common/texts';

export interface ResolveMiscInformation {
  icon: MediumIcon;
  text: string;
}

export const resolveMiscInformation = (
  hasLivestock: boolean,
  hasUnsavedHazardousGoods: boolean,
): ResolveMiscInformation | null => {
  if (hasLivestock) {
    return { text: Information.AnimalsInformation, icon: stenaAnimals };
  } else if (hasUnsavedHazardousGoods) {
    return { text: Information.HazardousGoodsRequested, icon: stenaHazardous };
  } else return null;
};
